module.exports = __webpack_public_path__ + "static/media/ucon10.f82b31d4.JPG";